import { render } from "./SpaTreatmentSearch.vue?vue&type=template&id=9d226c8e"
import script from "./SpaTreatmentSearch.vue?vue&type=script&lang=js"
export * from "./SpaTreatmentSearch.vue?vue&type=script&lang=js"

import "./SpaTreatmentSearch.vue?vue&type=style&index=0&id=9d226c8e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__